import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm";

const AstroVastu = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       <h2>Astro Vastu Services</h2>
                <p>
                    Bring Harmony and Positivity into Your Life through Vastu Aligned Spaces. At Jyotish karmaa, we specialize in <strong>Astro Vastu</strong> — a refined blend of traditional Vastu principles and astrological insights that help realign your space for better energy flow, well-being, and success.
                </p>

                <ul className="astro-benefits">
                    <li>
                    <strong>✅ Vastu-Based Positioning:</strong> We analyze the structure and direction of your home or office to align it with ancient Vastu wisdom — enhancing peace, prosperity, and happiness.
                    </li>
                    <li>
                    <strong>✅ Complete Property Evaluation:</strong> Our holistic approach reviews every room, entrance, corner, and utility area to ensure each section contributes positively to your overall energy.
                    </li>
                    <li>
                    <strong>✅ Simple, Practical Corrections:</strong> No major renovations needed. Our remedies are mostly non-invasive and tailored to your current setup — easy to apply, powerful in impact.
                    </li>
                    <li>
                    <strong>✅ Room-by-Room Energy Balancing:</strong> From bedrooms and kitchens to workspaces and meditation zones, we help you activate every space to support the purpose it serves.
                    </li>
                    <li>
                    <strong>✅ Scientific + Spiritual Integration:</strong> We combine logic with tradition — delivering solutions backed by both cosmic science and spiritual experience.
                    </li>
                    <li>
                    <strong>✅ Optimized Layout for Wellness & Growth:</strong> A well-aligned space supports mental clarity, stronger relationships, and improved finances. Let your home or office start working <em>for</em> you, not against you.
                    </li>
                    <li>
                    <strong>✅ Real Results, Proven Impact:</strong> Hundreds of clients report enhanced harmony, better decision-making, deeper sleep, smoother finances, and uplifted mood — all through subtle Vastu tuning.
                    </li>
                </ul>

        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <ContactForm />

       

       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default AstroVastu;
